import { connect } from "react-redux";
import * as Actions from "../commands/2step.authentication.actions";

function mapStateToProps(state) {
  return {
    AuthKey: state.twoStepAuthenticationReducer.AuthKey.value,
    AuthQr: state.twoStepAuthenticationReducer.AuthQr.value,
    fetching:
      state.twoStepAuthenticationReducer.AuthKey.fetching &&
      state.twoStepAuthenticationReducer.AuthQr.fetching,
    fetched:
      state.twoStepAuthenticationReducer.AuthKey.fetched &&
      state.twoStepAuthenticationReducer.AuthQr.fetched,
    Identity: state.twoStepAuthenticationReducer.Identity,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getQrCode: (username) => {
      dispatch(Actions.get_user_authentication_qr(username));
    },
    getUserKey: (username) => {
      dispatch(Actions.get_user_authentication_key(username));
    },
    addUserClaim: (userClaimInfo) => {
      dispatch(
        Actions.post_user_add_claim(
          userClaimInfo.username,
          userClaimInfo.claimName,
        ),
      );
    },
    addUserToAuth: (userInfo) => {
      dispatch(
        Actions.post_user_authentication(
          userInfo.username,
          userInfo.password,
          userInfo.confirmPassword,
          userInfo.givenName,
          userInfo.surname,
        ),
      );
    },
    getUserIdentity: (username) => {
      dispatch(Actions.get_user_identity(username));
    },
    changeUserPassword: (userInfo) => {
      dispatch(
        Actions.post_user_change_password(userInfo.username, userInfo.password),
      );
    },
  };
}

export const authConnector = connect(mapStateToProps, mapDispatchToProps);
